import { isEmpty } from 'lodash'

import fileValidation from 'components/PosAccounts/utils/validation'
import {
  posAccountsUtils,
  orgAttendantsFileErrorMessages,
} from 'components/PosAccounts/utils'
import { UPLOAD_ORG_ATTENDANTS_STEPS } from 'resources'

const handleUploadFile = (
  acceptedFiles,
  fileRejections,
  setFile,
  setStep
) => {
  if (!isEmpty(fileRejections)) {
    fileValidation.showUploadedFileErrors(fileRejections)
    return
  }

  setFile(acceptedFiles[0])
  setStep(UPLOAD_ORG_ATTENDANTS_STEPS.UPLOADED_FILE)
}

export const handleAttendantFormInBulkSubmit = (
  attendantsWithRoles,
  orgName,
  onBulkCreateAttendants
) => {
  return onBulkCreateAttendants(
    posAccountsUtils.transformParsedCSVFileToAttendantsAndRoles(
      attendantsWithRoles,
      orgName
    )
  )
}

/**
 * Transforms attendants with API errors into a structured format
 * that can be used to display errors in the UI,
 * because correct keys are necessary to display errors in the UI.
 *
 * @param {Object} errors - The errors object from the API response.
 * @param {Array} errors.attendants - The list of attendants.
 * @param {Array} errors.employeeRoles - The list of employee roles.
 * @returns {Array} - A list of transformed attendants with errors.
 */
const transformAttendantsWithAPIErrors = (errors) => {
  return (
    errors?.attendants
      ?.filter((attendant) => attendant?.errors)
      .map(({ employeeId, errorMessage, pinNumber, name }) => ({
        'First and Last Name': name,
        PIN: pinNumber,
        Role:
          errors?.employeeRoles.find(
            (role) => role?.employeeId === employeeId
          )?.role === 'manager'
            ? 'manager'
            : 'cashier',
        errors: [errorMessage],
      })) ?? []
  )
}

/**
 * Renders attendants with human-readable errors and transforms roles.
 * It is necessary to display errors in exported CSV file with errors.
 *
 * @param {Array} attendantsWithErrors - The list of attendants with errors.
 * @param {Object} attendantsWithErrors[].role - The role of the attendant.
 * @param {Array} attendantsWithErrors[].errors - The list of error codes for the attendant.
 * @returns {Array} - A new list of attendants with human-readable errors and transformed roles.
 */
const renderAttendantsWithHumanReadableErrors = (
  attendantsWithErrors
) => {
  return attendantsWithErrors.map((attendant) => ({
    ...attendant,
    Role:
      attendant.Role === 'cart_attendant'
        ? 'cashier'
        : attendant.Role,
    errors: attendant.errors
      .map((error) => orgAttendantsFileErrorMessages.get(error))
      .join(''), // Convert array of strings to a single string
  }))
}

const uploadFileUtils = {
  handleUploadFile,
  handleAttendantFormInBulkSubmit,
  transformAttendantsWithAPIErrors,
  renderAttendantsWithHumanReadableErrors,
}

export default uploadFileUtils
